import { createContext } from 'react-router';

// eslint-disable-next-line no-restricted-imports
import { type Member } from '@trello/graphql/generated';

export type UsernameContext = {
  memberId: Member['id'] | undefined;
  username: Member['username'] | undefined;
};

export const usernameContext = createContext<UsernameContext | null>(null);
